/**
 * @file index.tsx
 *
 * @fileoverview Shows the gallery widget when in view mode.
 */
import React from 'react';
import { OrganizationWidgetsBoxLabel } from '~/jobiqo/components/Organization/Widgets/BoxLabel';
import OrganizationVideoGalleryWidgetViewCotent from '~/jobiqo/components/Organization/Widgets/VideoGallery/View/components/Content';
import OrganizationVideoGalleryWidgetViewTitle from '~/jobiqo/components/Organization/Widgets/VideoGallery/View/components/Title';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';

export interface OrganizationVideoGalleryWidgetViewProps {
  /**
   * The current resume.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string | undefined;
}

export const OrganizationVideoGalleryWidgetView = (
  props: OrganizationVideoGalleryWidgetViewProps,
) => (
  <Box
    label={
      <OrganizationWidgetsBoxLabel {...props}>
        <OrganizationVideoGalleryWidgetViewTitle />
      </OrganizationWidgetsBoxLabel>
    }
  >
    <OrganizationVideoGalleryWidgetViewCotent {...props} />
  </Box>
);

export default OrganizationVideoGalleryWidgetView;
